import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Tutorial = () => {
    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography id="modal-modal-title" variant="h6">
                        E-Learning
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography fontWeight="700" color="primary">Tutorial Web</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container alignItems="center">
                                <Grid item xs={12} align="center">
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Mencari Titik Koordinat
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                    <iframe width="250" height="150" src="https://www.youtube.com/embed/V82kY0ktyuk" title="tutorial mencari titik koordinat" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Menu Setting
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/QMEsE1fdPmk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Menu Submitra
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/1L0nXt3LTXg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Update Mystock
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/8m69VOG9A4U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Konfirmasi DP PreOrder
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/8m69VOG9A4U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Konfirmasi Pembayaran StockDB
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/zzVZFYZTwzU" title="konfirmasi Pembayaran StockDB dan transaksi" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Fungsi Katalog
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/B5Fpj6GQyHY" title="menu katalog" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Order Distributor
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/-7UNRKdLnT8" title="Tutorial Order Distributor" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Melengkapi Profile
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/x5B2CF-jRjU" title="Update Profile Distributor" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Cara buka link po link khusus via japri
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/QLwj-dvPn6M" title="link po khusus" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Cek Saldo
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/W__eMpysjGE" title="cek saldo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Pre-order
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/TN5knDdQ4NU" title="order po 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="subtitle2" fontWeight="700" color="primary" align="left">
                                                Edit-preorder
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container alignItems="center">
                                                <Grid item xs={12} align="center">
                                                <iframe width="250" height="150" src="https://www.youtube.com/embed/7AFmROR9SR4" title="ubah order po 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography fontWeight="700" color="primary">Tips & Trik</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            tes
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Tutorial
